import { h } from 'preact'
import PropTypes from 'prop-types'

const Slot = ({ name }) => <slot name={name} />

Slot.propTypes = {
  name: PropTypes.string.isRequired,
}

export default Slot
